const wellcome = {
  phrase1: 'Olá',
  phrase2: 'seja bem-vindo(a)'
}

export default wellcome;
